<template>
	<file-upload v-bind:label-for="labelFor" v-bind:image-url="imageUrl" v-bind:min-resolution="minResolution"
	  v-bind:disable-validation="disableValidation" v-bind:max-resolution="maxResolution"
	  v-bind:preview-image="previewImage" v-on:file-info="fileInfo" v-on:file-error="fileError"
	  v-bind:allowed-files="allowedFiles">
	</file-upload>
</template>

<script>
import mixin from '@/shared/mixins';
import FileUpload from './FileUpload';

const ON_UPLOAD = 'upload';

function fileError(type) {
	if (type === 'type-not-allowed') {
		this.showNotification('El formato de imagen que intenta subir no es el correcto', 'error');
	} else {
		this.showNotification('La resolución de la imagen que intenta subir no es la correcta', 'error');
	}
}

function fileInfo(file, labelFor) {
	const imageUrl = `${process.env.MIDDLEWARE_URL}/image/one-upload`;
	this.$http
		.post(`${imageUrl}`, { type: file.ext, image: file.result })
		.then((response) => {
			this.$emit(ON_UPLOAD, response.data.data[0], labelFor);
		});
}

export default {
	name: 'file-upload-container',
	components: {
		FileUpload,
	},
	props: {
		allowedFiles: {
			type: Array,
			default: () => ['JPG', 'JPEG', 'PNG', 'GIF'],
		},
		disableValidation: {
			type: Boolean,
			default: false,
		},
		labelFor: {
			type: [String, Number],
			required: true,
		},
		imageUrl: {
			type: String,
			required: true,
		},
		maxResolution: {
			type: Number,
			default: 500,
		},
		minResolution: {
			type: Number,
			default: 500,
		},
		previewImage: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		fileError,
		fileInfo,
	},
	mixins: mixin,
};
</script>



// WEBPACK FOOTER //
// FileUploadContainer.vue?1224573a